import { useTranslation } from 'react-i18next';
import girlMp4 from "@/assets/video/girl.mp4"
import voiceGif from "@/assets/video/voice.gif"
import thoughtGif from "@/assets/video/thinking.gif"
import pointIcon from "@/assets/images/point.svg"
import { useCallback, useEffect, useRef, useState } from 'react';
import {useSpeechRecognition} from "./common";
import './index.less';
import flvjs from 'flv.js';
import { liveDemo,gptCall} from "@/api/videoApi";
function Login() {
  const { t } = useTranslation();
  const [textState,setTextState] = useState(true);
  const { startInit,stop,speechText,startState,startSpeak } = useSpeechRecognition(textState);
  const [videoState,setVideoState]= useState(true);
  const speechTextRef = useRef<any>(null);
  const flvPlayerRef = useRef<any>(null);
  const [questionState,setQuestionState] = useState(false);
  const oldTextRef = useRef('');
  const speakClick =()=>{
    oldTextRef.current ='';
    setTextState(false)
    startSpeak();
  }
  const stopClick=()=>{
    setTextState(true)
    stop();
    let index = 1;
    const stopInterval = window.setInterval(() => {
      index +=1;
      if(speechTextRef.current.state || index>100){
        window.clearInterval(stopInterval);
        console.log(oldTextRef.current)
        console.log(index)
        if(oldTextRef.current)
        sendClick(oldTextRef.current,speechTextRef.current.lang);
      }
    }, 100);
  }
  useEffect(() => {
    startInit();
	}, []);
  useEffect(() => {
    if(!startState){
      setTextState(true);
    }
	}, [startState]);
  useEffect(() => {
    speechTextRef.current = speechText;
    if(speechText.text && speechText.state){
      oldTextRef.current = oldTextRef.current+speechText.text;
    }
	}, [speechText]);

  const sendClick=(text:string,langugaeInfo:string)=>{
    setQuestionState(true);
    const langugae = getLanguage(langugaeInfo);
    flv_load_mds();
    try{
      getcall(text,langugae)
    }catch(error){
      console.log(error);
      setQuestionState(false)
    };
  }
  const getcall =(text:string,langugae:string)=>{
    gptCall(text,langugae).then(res=>{
      // console.log(res);
      setQuestionState(false)
    }).catch((error) => {
      console.log("error info",error);
      // getcall(text,langugae);
      setQuestionState(false)
    });
  }
  const getLanguage =(language:string)=>{
    // console.log(language);
    switch (language) {
      case 'en-US':
        return "en-US-JennyNeural";
      case 'ja-JP':
        return 'ja-JP-MayuNeural';
      case 'zh-CN':
        return 'zh-CN-XiaochenNeural';
      case 'ko-KR':
        return "ko-KR-SunHiNeural";
      case 'vi-VN':
        return 'vi-VN-HoaiMyNeural'
      default:
        return 'ja-JP-MayuNeural';
    }
  }
  function flv_load_mds() {
    if (flvPlayerRef.current) {
      destroyFlv();
    }
    try{
      let lastDecodedFrames = 0;
      const videoElement = document.getElementById('videoElement');
      const flvPlayer = flvjs.createPlayer({
        type: 'flv',
        isLive: true,
        hasAudio: true,
        hasVideo: true,
        url: import.meta.env.VITE_MOROSEYU_API_URL+'/live/livestream.flv',
      });
      flvPlayer.attachMediaElement(videoElement);
      flvPlayer.load();
      flvPlayer.play();
      flvPlayerRef.current = flvPlayer;
      flvPlayer.on(
        flvjs.Events.ERROR,
        (errorType, errorDetail, errorInfo) => {
          console.log('errorType',errorType)
          console.log('errorDetail',errorDetail)
          console.log('errorInfo',errorInfo)
          if(errorInfo.code ===504 || errorInfo.code ===-1){
            setVideoState(true);
            return;
          }
          // 添加错误处理逻辑
          const t = setInterval(function () {
            try{
              if (flvPlayer.buffered.end(0) - flvPlayer.currentTime < 1) {
                clearInterval(t);
                setTimeout(() => {
                  destroyFlv();
                  flv_load_mds();
                }, 1000);
                // videoStateRef.current = true;
                setVideoState(true);
              }
            }catch (e) {
              console.log(e);
              clearInterval(t);
                setTimeout(() => {
                  destroyFlv();
                  flv_load_mds();
                }, 1000);
                // videoStateRef.current = true;
                setVideoState(true);
            }
          }, 1000);
        }
      );
      flvPlayer.on(flvjs.Events.METADATA_ARRIVED, (res) => {
        console.log('METADATA_ARRIVED',res);
        // 添加元数据到达时的逻辑
        // videoStateRef.current = false;
        setTimeout(() => {
          setVideoState(false);
        }, 500);
      });
      flvPlayer.on('statistics_info', (res) => {
        console.log('statistics_info',res);
        // 添加统计信息逻辑
        if (lastDecodedFrames === 0) {
          lastDecodedFrames = res.decodedFrames;
          return;
        }
        if (lastDecodedFrames != res.decodedFrames) {
          lastDecodedFrames = res.decodedFrames;
        } else {
          lastDecodedFrames = 0;
          setVideoState(true);
          destroyFlv();
          flv_load_mds();
        }

      });
    }catch(e){
      setVideoState(true);
    }
  }
  const destroyFlv =()=> {
    flvPlayerRef.current.pause();
    flvPlayerRef.current.unload();
    flvPlayerRef.current.detachMediaElement();
    flvPlayerRef.current.destroy();
    flvPlayerRef.current = null;
  }
  return (
    <div className='human-content'>
      <div className='video-container'>
        <video
              loop
              className="centeredVideo"
              autoPlay
              src={girlMp4}
              muted={true}
              style={{ display: videoState?'block':'none'}}
        ></video>
         <video
						className="centeredVideo"
						id="videoElement"
						muted={false}
            autoPlay
            style={{ display: videoState?'none':'block'}}
					></video>
      </div>
      <div className='button-center'>
        <div className='voice-center'>
          <div className='voice-icon-content'>
            <img className='voice-icon' style={{display:textState?'none':'flex'}} src={voiceGif}/>
            <div className='vioce-text-content' style={{display:textState?'none':'flex'}}>
              <img className='text-icon' src={pointIcon}/>
              <div className='voice-text'>Listening</div>
            </div>

            <img className='voice-icon' style={{display:!questionState?'none':'flex'}} src={thoughtGif}/>
            <div className='vioce-text-content' style={{display:!questionState?'none':'flex'}}>
              <img className='text-icon' src={pointIcon}/>
              <div className='voice-text'>Thinking</div>
            </div>
          </div>
          <div className='start-button' style={{display:textState?'flex':'none'}}  onClick={speakClick}>Talk to Me</div>
          <div className='red-button' style={{display:textState?'none':'flex'}}  onClick={stopClick}>Finish Talk</div>
        </div>
      </div>
    </div>

  );
}

export default Login;
